// extracted by mini-css-extract-plugin
export default {"wrap":"DeleteProductInstanceDialog-wrap","cancelButton":"DeleteProductInstanceDialog-cancelButton","deleteButton":"DeleteProductInstanceDialog-deleteButton"};